module.exports = __webpack_public_path__ + "img/vedio.81dbf13.png";